const qrobotSteps= [
    {
      content: <h2>Let's begin !</h2>,
      locale: { skip: <strong>SKIP</strong> },
      placement: "center",
      target: "body"
    },
    {
      content: <h2>To create a survey, you must enter the survey title in this field.</h2>,
      placement: "bottom",
      target: "#qrobotSurveyTitle",
      title: "Survey Title"
    },
    {
      content: <h2>Here, you can enter the details of your survey depending on how you want the survey content to be.</h2>,      
      placement: "bottom",
      target: "#qrobotSurveyDetail",
      title: "Second step"
    },
    {
      content: <h2>You can enter your desired topics here or generate sample topics with the help of AI.</h2>,
      placement: "bottom",
      target: "#qrobotSurveyTopics",
      title: "Third step"
    },
  ]
  export default qrobotSteps;